module.exports = __webpack_public_path__ + "img/beijingindex.8950e733.jpg";